module.exports = __webpack_public_path__ + "a5d29eb213ce868f0e6f81228093e5fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-32.png
// module id = 2366
// module chunks = 0